import React__default from 'react';

function calculateVh() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    requestAnimationFrame(calculateVh);
}
const useAddViewportHeightCssVariable = ()=>{
    React__default.useEffect(()=>{
        // if already --vh is applied on body, do nothing
        if (document.documentElement.style.getPropertyValue('--vh')) {
            console.warn('Viewport height css variable `--vh` not applied to document, variable has already been set');
            return;
        }
        requestAnimationFrame(calculateVh);
        window.addEventListener('resize', calculateVh);
        window.addEventListener('orientationchange', calculateVh);
        // Cleanup event listeners
        return ()=>{
            window.removeEventListener('resize', calculateVh);
            window.removeEventListener('orientationchange', calculateVh);
            document.documentElement.style.removeProperty('--vh');
        };
    }, []);
};

export { useAddViewportHeightCssVariable };
//# sourceMappingURL=use-add-viewport-height-css-variable.js.map
